import { Palette } from '@/types/theme';
import { FunctionComponent } from 'react';
import { Link as NavLink } from 'react-router-dom';
import { styled } from 'styled-components';

export type ButtonProps = JSX.IntrinsicElements['button'] & {
    variant?: 'outlined' | 'solid' | 'text';
    href?: string;
    color?: keyof Palette;
    className?: string;
    disabled?: boolean;
};

const Button: FunctionComponent<ButtonProps> = (props) => {
    const { href, children, variant = 'solid', color = 'primary', ...buttonProps } = props;

    return href ? (
        <StyledButton variant={variant} color={color} {...buttonProps}>
            <StyledLink to={href}>{children} </StyledLink>
        </StyledButton>
    ) : (
        <StyledButton variant={variant} color={color} {...buttonProps}>
            {children}
        </StyledButton>
    );
};

const StyledButton = styled.button<ButtonProps>`
    max-width: fit-content;
    background-color: ${(props) =>
        props.variant === 'solid' ? props.theme.palette[props.color ?? 'primary'] : 'white'};
    color: ${(props) => (props.variant === 'solid' ? 'white' : props.theme.palette[props.color ?? 'primary'])};
    padding: 0.5rem 1rem;
    border: ${(props) =>
        props.variant === 'outlined' || props.variant === 'solid'
            ? `0.06rem solid ${props.theme.palette[props.color ?? 'primary']}`
            : ''};
    transition: all 0.4s;
    border-radius: 0.5rem;

    &:hover {
        opacity: 0.8;
        background-color: ${(props) =>
            props.variant !== 'solid' ? props.theme.palette[props.color ?? 'primary'] + '0F' : undefined};
    }

    &:disabled {
        opacity: 0.5;
    }
`;

const StyledLink = styled(NavLink)`
    cursor: pointer;
    color: inherit;
`;
export default Button;
